import * as React from 'react'
import App from './App'
import { createRoot } from 'react-dom/client'
import { datadogRum } from '@datadog/browser-rum'
import { hotjar } from 'react-hotjar'
import '../config/i18n/i18n'

const packageJson = require('../package.json')

if (process.env.ENVIRONMENT !== 'development') {
  datadogRum.init({
    applicationId: process.env.DATADOG_APP_ID || '',
    clientToken: process.env.DATADOG_CLIENT_TOKEN || '',
    defaultPrivacyLevel: 'mask-user-input',
    sampleRate: 100,

    service: process.env.DATADOG_SERVICE || '',

    site: 'datadoghq.com',

    trackInteractions: true,
    // Specify a version number to identify the deployed version of your application in Datadog
    version: packageJson?.version
  })
}

hotjar.initialize(Number(process.env.HOTJAR_ID), Number(process.env.HOTJAR_SNIPPET_VERSION))

const container = document.getElementById('root') as Element
const root = createRoot(container)

root.render(<App />)
